import { Id, LaravelResponse, PaginatedListFetcherConfig, keyToUrl } from "@dgs/core";
import axios from "axios";
import {
	DresoConfig,
	IntegrationCreateRequest,
	IntegrationIndexResource,
	IntegrationResource,
} from "../types/integration";

// DresoConfig = DresoConfigEntry[] — the update endpoint receives the full mappings array

const baseKey = ["integrations"];

export const integrationService = {
	indexKey: [...baseKey],
	listKey: [...baseKey, "list"],
	showKey: (id: Id) => [...baseKey, `${id}`],
	index: (config: PaginatedListFetcherConfig<IntegrationIndexResource>) =>
		axios.get<LaravelResponse<IntegrationIndexResource[]>>(keyToUrl(baseKey), {
			params: { ...config.searchParams, ...config.pageParams },
		}),
	show: (id: Id) => axios.get<LaravelResponse<IntegrationResource>>(`${keyToUrl(baseKey)}/${id}`),
	create: (data: IntegrationCreateRequest) => axios.post<LaravelResponse<IntegrationResource>>(keyToUrl(baseKey), data),
	update: (id: Id, config: DresoConfig) => axios.put(`${keyToUrl(baseKey)}/${id}`, { config }),
	destroy: (id: Id) => axios.delete(`${keyToUrl(baseKey)}/${id}`),
};
